/**
 * The font registry now lives in the shared `@ps/functions/fonts` so foundation
 * packages (the RichTextEditor in `libs/ui`) can use it too. Re-exported here so
 * the bio consumers of this path keep working unchanged.
 */
export * from '@ps/functions/fonts';
export type {
  ExportedFontFamily,
  FontVariantOption,
} from '@ps/functions/fonts';
